<!-- PDF Preview -->
<app-deprecated-modal #documentPreview>
    <app-pdf-viewer #pdfViewer></app-pdf-viewer>
</app-deprecated-modal>

<div class="ui basic segment" [class.loading]="isLoading">
    <ng-container *ngIf="!isLoading">
        <app-header title="{{ 'account.benefits.yourBenefitsPlan' | appTranslate }}">
            <div
                class="buttons"
                *ngIf="employeeBenefitPlan?.benefitPlan?.hasEnhancedManagedBenefits && !this.hasPendingChangeRequests"
            >
                <ui-button type="primary" (click)="onChangeRequest()">{{
                    'account.benefits.requestChange' | appTranslate
                }}</ui-button>
            </div>
        </app-header>
        <app-benefits-change-request-banner
            *ngIf="employeeBenefitPlan?.benefitPlan?.hasEnhancedManagedBenefits"
            [employeeBenefitPlan]="employeeBenefitPlan"
        ></app-benefits-change-request-banner>
        <div class="ui layout">
            <div class="content">
                <!-- Benefits Card/Enrollment -->
                <div class="ui segment">
                    <app-segment-header
                        title="{{ 'account.benefits.employmentBenefitsPlan' | appTranslate }}"
                    ></app-segment-header>
                    <!-- Empty -->
                    <div *ngIf="!employeeBenefitPlan?.id" class="empty">
                        <img src="/assets/illustrations/benefits.png" />
                        <h2 class="ui centered header">
                            {{ 'account.benefits.noBenefitsPlanHasBeenConfigured' | appTranslate }}
                        </h2>
                    </div>

                    <div *ngIf="employeeBenefitPlan?.benefitPlan" class="flex middle start">
                        <div class="inner flex start middle">
                            <app-benefits-card
                                *ngIf="shouldShowCard"
                                [employee]="employee"
                                [benefits]="employeeBenefitPlan"
                            ></app-benefits-card>
                            <div class="benefits-header" [ngStyle]="{ margin: shouldShowCard ? '' : '0px' }">
                                <h2 class="ui header">
                                    {{
                                        employeeBenefitPlan?.benefitPlan?.benefitProvider?.name ||
                                            ('account.benefits.noProvider' | translate)
                                    }}
                                </h2>
                                <p>
                                    {{ 'employees.benefits.waitingPeriod' | appTranslate }}
                                    {{
                                        (employeeBenefitPlan?.isWaitingPeriodWaved
                                            ? 'employees.benefits.waitingPeriodAsNull'
                                            : employeeBenefitPlan?.benefitPlan?.probationPeriodDescription
                                        ) | appTranslate
                                    }}
                                </p>
                                <p *ngIf="employeeBenefitPlan?.benefitPlan?.fileId">
                                    <a (click)="onDownloadPlan(employeeBenefitPlan?.benefitPlan)">{{
                                        'account.benefits.downloadBenefitsBooklet' | appTranslate
                                    }}</a>
                                </p>
                                <p *ngIf="employeeBenefitPlan?.benefitPlan?.planUrl">
                                    <a target="_blank" [attr.href]="employeeBenefitPlan?.benefitPlan?.planUrl">{{
                                        'account.benefits.viewPlan' | appTranslate
                                    }}</a>
                                </p>
                                <p>
                                    <a
                                        [attr.href]="employeeBenefitPlan?.benefitPlan?.benefitProvider?.portalUrl"
                                        target="_blank"
                                        >{{ 'account.benefits.carrierPortal' | appTranslate }}</a
                                    >
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Benefits -->
                <div *ngFor="let benefit of employeeBenefitPlan?.benefitPlan?.benefits" class="ui segment benefit">
                    <app-segment-header
                        [title]="benefit.benefitCategory?.name"
                        [collapsible]="true"
                    ></app-segment-header>

                    <div class="content">
                        <!-- Provider and File -->
                        <div class="logo">
                            <img
                                *ngIf="benefit.benefitProvider"
                                class="ui image"
                                [attr.src]="'/assets/img/brands/' + benefit.benefitProvider?.logoUrl"
                            />
                            <span *ngIf="benefit.fileId && !benefit.benefitProvider"
                                ><i class="fa fal fa-3x fa-file"></i><br /><br
                            /></span>
                            <ui-button
                                type="link"
                                *ngIf="benefit.fileId"
                                (click)="onDownloadBenefit(employeeBenefitPlan?.benefitPlan, benefit)"
                                >{{ 'account.benefits.downloadBooklet' | appTranslate }}
                            </ui-button>
                        </div>
                        <div class="benefit-description">{{ benefit.description }}</div>
                        <!-- Benefit Detail Without Type -->
                        <div *ngFor="let detail of benefit.benefitDetails | groupBy: 'benefitTypeId'" class="benefit">
                            <ng-container *ngIf="!detail.value[0]?.benefitType">
                                <!-- Coverage Descriptions -->
                                <div *ngFor="let coverage of detail.value" class="benefit-detail-description">
                                    <div class="benefit-description">{{ coverage.description }}</div>
                                </div>
                                <!-- Coverages -->
                                <div *ngFor="let coverage of detail.value" class="benefit-details">
                                    <div class="ui static form">
                                        <div *ngIf="coverage.coverage" class="inline field">
                                            <label>{{ 'account.benefits.coverage' | appTranslate }}</label>
                                            {{ coverage.coverage }}%
                                        </div>
                                        <div *ngIf="coverage.reimbursement" class="inline field">
                                            <label>{{ 'account.benefits.reimbursement' | appTranslate }}</label>
                                            {{ coverage.reimbursement | currency }}
                                        </div>
                                        <div *ngIf="coverage.deductible" class="inline field">
                                            <label>{{ 'account.benefits.deductible' | appTranslate }}</label>
                                            {{ coverage.deductible | currency }}
                                        </div>
                                        <div *ngIf="coverage.max" class="inline field">
                                            <label>{{ 'account.benefits.maximum' | appTranslate }}</label>
                                            {{ coverage.max | currency }}
                                        </div>
                                        <div *ngIf="coverage.nem" class="inline field">
                                            <label>{{ 'account.benefits.nonEvidenceMaximum' | appTranslate }}</label>
                                            {{ coverage.nem | currency }}
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                        <!-- Benefit Details With Type -->
                        <div
                            *ngFor="let detail of benefit.benefitDetails | groupBy: 'benefitTypeId'"
                            class="benefitWithType"
                        >
                            <ng-container *ngIf="detail.value[0]?.benefitType">
                                <h4 class="ui header">{{ detail.value[0].benefitType?.name }}</h4>
                                <!-- Coverage Descriptions -->
                                <div *ngFor="let coverage of detail.value" class="benefit-detail-description">
                                    <div class="benefit-description">{{ coverage.description }}</div>
                                </div>
                                <!-- Coverages -->
                                <div *ngFor="let coverage of detail.value" class="benefit-details">
                                    <div class="ui static form">
                                        <div *ngIf="coverage.coverage" class="inline field">
                                            <label>{{ 'account.benefits.coverage' | appTranslate }}</label>
                                            {{ coverage.coverage }}%
                                        </div>
                                        <div *ngIf="coverage.reimbursement" class="inline field">
                                            <label>{{ 'account.benefits.reimbursement' | appTranslate }}</label>
                                            {{ coverage.reimbursement | currency }}
                                        </div>
                                        <div *ngIf="coverage.deductible" class="inline field">
                                            <label>{{ 'account.benefits.deductible' | appTranslate }}</label>
                                            {{ coverage.deductible | currency }}
                                        </div>
                                        <div *ngIf="coverage.max" class="inline field">
                                            <label>{{ 'account.benefits.maximum' | appTranslate }}</label>
                                            {{ coverage.max | currency }}
                                        </div>
                                        <div *ngIf="coverage.nem" class="inline field">
                                            <label>{{ 'account.benefits.nonEvidenceMaximum' | appTranslate }}</label>
                                            {{ coverage.nem | currency }}
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                        <div class="clear"></div>
                    </div>
                </div>
            </div>
            <div class="sidebar">
                <div class="ui segment">
                    <app-segment-header
                        title="{{ 'account.benefits.benefitDisclaimer' | appTranslate }}"
                    ></app-segment-header>
                    <p>{{ 'account.benefits.referToYourBenefitsBooklet' | appTranslate }}</p>
                    <p>{{ 'account.benefits.ifYouElectedToWaive' | appTranslate }}</p>
                </div>
            </div>
        </div>
    </ng-container>
</div>
